import React from 'react';
import type { Size } from '../../types';

const arbitrum = (width: Size = '120', height: Size = '160') => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0,0,120,160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.3"
                d="M9.09277 104.682V108.659L20.1229 115.042L24.4793 117.54L37.5487 125.033L53.1206 134.006C53.6767 134.283 54.1402 134.561 54.5109 134.746C55.0671 135.116 55.5305 135.301 55.6232 135.393C56.7355 135.948 58.3112 136.226 59.7943 136.226C61.0919 136.226 62.3896 135.948 63.5946 135.486L106.139 110.88C108.549 109.029 110.032 106.162 110.125 103.017V56.0242C110.032 52.6015 108.086 49.4564 105.212 47.6063L64.2434 24.1101C61.37 22.63 57.7551 22.63 54.8817 24.1101C54.5109 24.2951 15.0249 47.1437 15.0249 47.1437C14.4688 47.4213 13.9127 47.6988 13.4492 48.0688C10.8539 49.9189 9.27815 52.879 9.09277 56.0242L9.09277 104.682Z"
                fill="url(#paint0_linear_173_19021)"
            />
            <path
                d="M59.5161 25.7751C60.7211 25.7751 61.9261 26.0527 62.9457 26.5152L103.822 49.9189C105.954 51.3065 107.252 53.5266 107.437 56.0242V102.924C107.344 105.144 106.325 107.179 104.656 108.474L62.4822 132.896C61.648 133.173 60.7211 133.358 59.8869 133.358C58.8673 133.358 57.6623 133.173 57.0135 132.803C56.8281 132.711 56.55 132.526 55.9939 132.248C55.6231 132.063 55.1597 131.786 54.6962 131.508L39.1243 122.535L26.055 115.042L21.6986 112.545L11.8734 107.087V104.682V56.1167C11.9661 53.8041 13.1711 51.6765 15.1175 50.3814C15.4883 50.1039 15.8591 49.9189 16.2298 49.7339L16.3225 49.6414L16.4152 49.5489C29.6699 41.871 54.7889 27.3477 56.1793 26.6077C57.1989 26.0527 58.3112 25.7751 59.5161 25.7751ZM59.5161 23C57.8477 23 56.272 23.37 54.7889 24.1101C54.4182 24.2951 14.9322 47.1437 14.9322 47.1437C14.376 47.4213 13.8199 47.6988 13.3564 48.0688C10.7611 49.9189 9.18538 52.879 9 56.0242V104.682V108.659L20.0301 115.042L24.3866 117.54L37.4559 125.033L53.0278 134.006C53.584 134.283 54.0474 134.561 54.4182 134.746C54.9743 135.116 55.4378 135.301 55.5305 135.393C56.6427 135.948 58.2185 136.226 59.7015 136.226C60.9992 136.226 62.2968 135.948 63.5018 135.486L106.139 110.88C108.549 109.029 110.032 106.162 110.125 103.017V56.0242C110.032 52.6015 108.086 49.4564 105.212 47.6063L64.2433 24.1101C62.853 23.37 61.1846 23 59.5161 23Z"
                fill="url(#paint1_linear_173_19021)"
            />
            <path
                opacity="0.7"
                d="M61.7406 96.3563L77.4052 120.87L91.8649 112.545L71.3804 80.168L61.7406 96.3563Z"
                fill="url(#paint2_linear_173_19021)"
            />
            <path
                opacity="0.7"
                d="M105.027 102.647V95.9863L82.596 61.0195L74.2539 75.1727L95.9434 110.139L103.822 105.607C104.564 104.959 105.027 104.034 105.12 103.109L105.027 102.647Z"
                fill="url(#paint3_linear_173_19021)"
            />
            <path
                d="M20.4935 113.007L56.0865 56.1168L50.8032 55.9318C45.4272 55.8393 39.6804 57.2269 37.0851 61.5746L16.1371 93.9512L10.5757 102.462V108.012"
                fill="url(#paint4_linear_173_19021)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M36.2359 61.0461C39.1281 56.221 45.3738 54.8382 50.8204 54.9319L50.8293 54.9321L57.8534 55.178L21.3413 113.538L19.6458 112.477L54.3196 57.0555L50.7772 56.9315C45.4807 56.842 40.2451 58.2318 37.9437 62.0871L37.9345 62.1026L16.9767 94.4944L16.9742 94.4983L11.5757 102.759V108.012H9.57568V102.164L15.2975 93.408L15.3 93.4042L36.2359 61.0461Z"
                fill="url(#paint5_linear_173_19021)"
            />
            <path
                d="M37.5487 125.033L41.0709 119.02L78.2396 56.1167L63.5946 56.2092L25.4062 117.54"
                fill="url(#paint6_linear_173_19021)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M79.9985 55.1056L41.9336 119.525L41.9317 119.529L38.4114 125.538L36.6857 124.527L40.2079 118.515L40.2098 118.511L76.4805 57.1279L64.152 57.2058L26.255 118.068L24.5573 117.011L63.0369 55.2128L79.9985 55.1056Z"
                fill="url(#paint7_linear_173_19021)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_173_19021"
                    x1="9.09278"
                    y1="79.6129"
                    x2="110.145"
                    y2="79.6129"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_173_19021"
                    x1="59.5625"
                    y1="23"
                    x2="59.5625"
                    y2="136.226"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" stopOpacity="0.2" />
                    <stop offset="0.348958" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_173_19021"
                    x1="61.7842"
                    y1="100.517"
                    x2="91.8902"
                    y2="100.517"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_173_19021"
                    x1="74.255"
                    y1="85.6105"
                    x2="105.056"
                    y2="85.6105"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_173_19021"
                    x1="10.5592"
                    y1="84.4857"
                    x2="56.0717"
                    y2="84.4857"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_173_19021"
                    x1="33.3311"
                    y1="55.9275"
                    x2="33.3311"
                    y2="113.007"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_173_19021"
                    x1="25.4314"
                    y1="90.5737"
                    x2="78.2591"
                    y2="90.5737"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_173_19021"
                    x1="51.8227"
                    y1="56.1168"
                    x2="51.8227"
                    y2="125.033"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default arbitrum;
